<div class="column spacing-24" style="padding-bottom: 72px">
	<div class="content-container">
		<div class="content-container-header">
			<h3 i18n="@@addDeviceNoteDetails-noteHeader"><b>Note</b></h3>
			<p i18n="@@addDeviceNoteDetails-noteDescription">Leave a note for others in your company to read.</p>

			<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
				<textarea
					#txtarea
					matInput
					maxlength="2000"
					class="textarea-height"
					[(ngModel)]="appVisitNote.note"
					placeholder=""
					data-automation-id="app-visit-note-textarea"
				></textarea>
			</mat-form-field>
		</div>

		<div class="content-container-header">
			<h3 i18n="@@addDeviceNoteDetails-notePhotoUpload"><b>Photo Upload</b></h3>
			<p i18n="@@addDeviceNoteDetails-notePhotoUploadDescription">
				Take better notes for future visits by including photos.
			</p>

			<div class="content-container-body">
				<div class="row">
					<div class="dropzone content-container-body column spacing-12" appDnd (files)="onFileSelected($event)">
						<input
							type="file"
							id="fileDnd"
							#fileDnd
							class="file-input"
							(change)="onFileSelected($event)"
							#fileUpload
							multiple
							accept="image/*"
							data-automation-id="file-select-input"
						/>
						<mat-icon matTooltip="{{ uploadPhotoTooltip }}">cloud_upload</mat-icon>
						<br />
						<h3 i18n="@@addDeviceNoteDetails-notePhotoUploadDragImage">Drag image to upload</h3>
						<h3 i18n="@@addDeviceNoteDetails-notePhotoUploadOr">or</h3>
						<label i18n="@@addDeviceNoteDetails-notePhotoUploadBrowseFile" class="file-upload" for="fileDnd"
							>Browse files</label
						>
					</div>
					<div class="photo-spec content-container-body column">
						<label i18n="@@addDeviceNoteDetails-photoSpec"
							>.JPEG and .PNG image files are acceptd. <br />
							Images should not exceed 2MB in size.</label
						>
					</div>
				</div>

				<div class="note-photo row">
					@if (fileDetails.length > 0) {
						<div>
							<h3 i18n="@@addDeviceNoteDetails-photoAdded"><b>Photo Added</b></h3>
							<div class="container">
								<div class="col-1">
									<p i18n="@@addDeviceNoteDetails-photoAdded-col-Image">Image</p>
								</div>
								<div class="col-2">
									<p i18n="@@addDeviceNoteDetails-photoAdded-col-FileName">File Name</p>
								</div>
								<div class="col-3">
									<p i18n="@@addDeviceNoteDetails-photoAdded-col-Caption">Caption (Optional)</p>
								</div>
								<div class="col-4"></div>
							</div>
							@for (fileDetail of fileDetails; track fileDetail.file.name) {
								<div
									class="photo-row container"
									[attr.data-automation-id]="'file-select-' + fileDetail.file.name + '-row'"
								>
									<div class="photo-preview col-2">
										@if (!isFileTypeValid(fileDetail.file) || !isFileSizeValid(fileDetail.file)) {
											<div class="refresh-icon">
												<mat-icon matTooltip="{{ photoTooltip }}">refresh</mat-icon>
											</div>
										}
										@if (isFileTypeValid(fileDetail.file) && isFileSizeValid(fileDetail.file)) {
											<img [src]="fileDetail.previewURL" alt="Preview" />
										}
									</div>
									<div class="photo-file-name col-3">
										<div>
											{{ fileDetail.file.name }}
										</div>
									</div>
									<div class="photo-caption col-3">
										<input type="text" [(ngModel)]="fileDetail.caption" placeholder="" />
										@if (!isFileTypeValid(fileDetail.file)) {
											<div
												class="file-error"
												i18n="@@addDeviceNoteDetails-photoAdded-invalidFile"
												data-automation-id="file-select-error"
											>
												Invalid file type. Please upload an image file (JPEG, JPG, or PNG) for your upload.
											</div>
										}
										@if (!isFileSizeValid(fileDetail.file)) {
											<div
												class="file-error"
												i18n="@@addDeviceNoteDetails-photoAdded-fileSizeExceeded"
												data-automation-id="file-select-error"
											>
												File size exceeded. Please ensure your image is under 2MB for successful upload.
											</div>
										}
									</div>
									<div class="photo-upload-delete col-4">
										<mat-icon
											class="cancel-delete"
											matTooltip="{{ removePhotoTooltip }}"
											(click)="removeFile(fileDetail.file)"
											[attr.data-automation-id]="'delete-file-' + fileDetail.file.name"
											>delete_outline</mat-icon
										>
									</div>
								</div>
							}
						</div>
					}
				</div>
			</div>
		</div>
	</div>
</div>
